// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

// shopping cart
frappe.provide("webshop.webshop.shopping_cart");
var shopping_cart = webshop.webshop.shopping_cart;

var getParams = function (url) {
	var params = [];
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

frappe.ready(function() {
	var full_name = frappe.session && frappe.session.user_fullname;
	// update user
	if(full_name) {
		$('.navbar li[data-label="User"] a')
			.html('<i class="fa fa-fixed-width fa fa-user"></i> ' + full_name);
	}
	// set coupon code and sales partner code

	var url_args = getParams(window.location.href);

	var referral_coupon_code = url_args['cc'];
	var referral_sales_partner = url_args['sp'];

	var d = new Date();
	// expires within 30 minutes
	d.setTime(d.getTime() + (0.02 * 24 * 60 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	if (referral_coupon_code) {
		document.cookie = "referral_coupon_code=" + referral_coupon_code + ";" + expires + ";path=/";
	}
	if (referral_sales_partner) {
		document.cookie = "referral_sales_partner=" + referral_sales_partner + ";" + expires + ";path=/";
	}
	referral_coupon_code=frappe.get_cookie("referral_coupon_code");
	referral_sales_partner=frappe.get_cookie("referral_sales_partner");

	if (referral_coupon_code && $(".tot_quotation_discount").val()==undefined ) {
		$(".txtcoupon").val(referral_coupon_code);
	}
	if (referral_sales_partner) {
		$(".txtreferral_sales_partner").val(referral_sales_partner);
	}

	// update login
	shopping_cart.show_shoppingcart_dropdown();
	shopping_cart.set_cart_count();
	shopping_cart.show_cart_navbar();

	// Re-sync cart count when the page is restored from bfcache
	$(window).on('pageshow', function(event) {
		if (event.originalEvent && event.originalEvent.persisted) {
			frappe.call({
				method: 'webshop.webshop.shopping_cart.cart.get_cart_quotation',
				callback: function(r) {
					if (r.message && r.message.doc) {
						var total_qty = 0;
						(r.message.doc.items || []).forEach(function(it) { total_qty += it.qty || 0; });
						shopping_cart.set_cart_count(false, total_qty);
					} else {
						shopping_cart.set_cart_count(false, 0);
					}
				}
			});
		}
	});

	// Bind Add to Cart globally once the bundle is loaded.
	// Detail pages render the button inside item_add_to_cart.html, so this
	// ensures the click handler is attached even when inline scripts run first.
	shopping_cart.bind_add_to_cart_action();
});

$.extend(shopping_cart, {
	show_shoppingcart_dropdown: function() {
		$(".shopping-cart").on('shown.bs.dropdown', function() {
			// Always fetch fresh dropdown HTML so removed items never linger.
			return frappe.call({
				method: 'webshop.webshop.shopping_cart.cart.get_shopping_cart_menu',
				callback: function(r) {
					if (r.message) {
						$('.shopping-cart-menu').html(r.message);
					}
				}
			});
		});
	},

	update_cart: function(opts) {
		if (frappe.session.user==="Guest") {
			if (localStorage) {
				localStorage.setItem("last_visited", window.location.pathname);
			}
			frappe.call('webshop.webshop.api.get_guest_redirect_on_action').then((res) => {
				window.location.href = res.message || "/login";
			});
		} else {
			shopping_cart.freeze();
			return frappe.call({
				type: "POST",
				method: "webshop.webshop.shopping_cart.cart.update_cart",
				args: {
					item_code: opts.item_code,
					qty: opts.qty,
					additional_notes: opts.additional_notes !== undefined ? opts.additional_notes : undefined,
					with_items: opts.with_items || 0,
					uom: opts.uom || null
				},
				btn: opts.btn,
				callback: function(r) {
					shopping_cart.unfreeze();
					var server_count = (r.message && r.message.cart_count !== undefined) ? r.message.cart_count : null;
					shopping_cart.set_cart_count(true, server_count);
					// Force the dropdown to reload the next time it opens
					$('.shopping-cart-menu').empty();
					if(opts.callback)
						opts.callback(r);
				}
			});
		}
	},

	set_cart_count: function(animate=false, count=null) {
		$(".intermediate-empty-cart").remove();

		var cart_count = (count !== null) ? count : frappe.get_cookie("cart_count");
		if(frappe.session.user==="Guest") {
			cart_count = 0;
		}
		cart_count = parseInt(cart_count) || 0;

		var $cart = $('.cart-icon');
		var $badge = $cart.find("#cart-count");

		// Always keep the badge element so it can be updated later
		if (cart_count === 0) {
			$(".shopping-cart").addClass('hidden');
			$cart.css("display", "none");
			if ($badge.length) {
				$badge.text(0);
			}

			if (window.location.pathname === "/cart") {
				$(".cart-tax-items").hide();
				$(".btn-place-order").hide();
				$(".cart-payment-addresses").hide();

				let intermediate_empty_cart_msg = `
					<div class="text-center w-100 intermediate-empty-cart mt-4 mb-4 text-muted">
						${ __("Cart is Empty") }
					</div>
				`;
				$(".cart-table").after(intermediate_empty_cart_msg);
			}
		}
		else {
			$(".shopping-cart").removeClass('hidden');
			$cart.css("display", "inline");

			if (!$badge.length) {
				// Recreate badge if it was removed by a previous empty-cart state
				$cart.find("a").first().append(
					'<span class="badge badge-primary shopping-badge" id="cart-count"></span>'
				);
				$badge = $cart.find("#cart-count");
			}

			$badge.text(cart_count);

			if (animate) {
				$cart.addClass("cart-animate");
				setTimeout(() => {
					$cart.removeClass("cart-animate");
				}, 500);
			}
		}
	},

	shopping_cart_update: function({item_code, qty, cart_dropdown, additional_notes, uom}) {
		shopping_cart.update_cart({
			item_code,
			qty,
			additional_notes,
			uom,
			with_items: 1,
			btn: this,
			callback: function(r) {
				if(!r.exc) {
					$(".cart-items").html(r.message.items);
					$(".cart-tax-items").html(r.message.total);
					$(".payment-summary").html(r.message.taxes_and_totals);
					shopping_cart.set_cart_count(false, r.message.cart_count || 0);

					if (cart_dropdown != true) {
						$(".cart-icon").hide();
					}
				}
			},
		});
	},

	show_cart_navbar: function () {
		frappe.call({
			method: "webshop.webshop.doctype.webshop_settings.webshop_settings.is_cart_enabled",
			callback: function(r) {
				$(".shopping-cart").toggleClass('hidden', r.message ? false : true);
			}
		});
	},

	toggle_button_class(button, remove, add) {
		button.removeClass(remove);
		button.addClass(add);
	},

	bind_add_to_cart_action() {
		$('.page_content').on('click', '.btn-add-to-cart-list', (e) => {
			const $btn = $(e.currentTarget);

			// Prevent duplicate clicks / double-firing Add-to-Cart requests.
			// Disabled attribute alone is not enough because the click event may
			// already be queued; use a per-button flag as well.
			if ($btn.data('adding-to-cart') || $btn.prop('disabled')) return;
			$btn.data('adding-to-cart', true);
			$btn.prop('disabled', true);

			if (frappe.session.user === "Guest") {
				if (localStorage) {
					localStorage.setItem("last_visited", window.location.pathname);
				}
				frappe.call('webshop.webshop.api.get_guest_redirect_on_action').then((res) => {
					window.location.href = res.message || "/login";
				});
				return;
			}

			const item_code = $btn.data('item-code');
			const uom = $btn.data('uom') || null;
			webshop.webshop.shopping_cart.update_cart({
				item_code,
				qty: 1,
				uom: uom,
				callback: function(r) {
					if (r && r.message) {
						// Determine which view this button belongs to
						let view = 'list';
						if ($btn.closest('.item-card').length > 0) view = 'grid';
						else if ($btn.closest('.item-cart').length > 0) view = 'detail';

						$btn.replaceWith(webshop_qty_selector_html(item_code, 1, view, uom));
						webshop_update_bubble(item_code, 1, uom);

						// Sync other view instances of the same item/UOM
						['.grid-qty-selector', '.list-qty-selector', '.detail-qty-selector'].forEach(function(sel) {
							const $other = $(sel + '[data-item-code="' + item_code + '"]' + (uom ? '[data-uom="' + uom + '"]' : ''));
							if ($other.length) {
								$other.find('.qs-qty[data-item-code="' + item_code + '"]').val(1);
							}
						});
						// Also convert any other Add to Cart buttons for the same item
						$('.btn-add-to-cart-list[data-item-code="' + item_code + '"]').each(function() {
							const $other_btn = $(this);
							if ($other_btn.is($btn)) return;
							let other_view = 'list';
							if ($other_btn.closest('.item-card').length > 0) other_view = 'grid';
							else if ($other_btn.closest('.item-cart').length > 0) other_view = 'detail';
							$other_btn.replaceWith(webshop_qty_selector_html(item_code, 1, other_view, uom));
						});
					} else {
						$btn.prop('disabled', false);
						$btn.removeData('adding-to-cart');
					}
				}
			});
		});
	},

	freeze() {
		if (window.location.pathname !== "/cart") return;

		if (!$('#freeze').length) {
			let freeze = $('<div id="freeze" class="modal-backdrop fade"></div>')
				.appendTo("body");

			setTimeout(function() {
				freeze.addClass("show");
			}, 1);
		} else {
			$("#freeze").addClass("show");
		}
	},

	unfreeze() {
		if ($('#freeze').length) {
			let freeze = $('#freeze').removeClass("show");
			setTimeout(function() {
				freeze.remove();
			}, 1);
		}
	}
});